import { Link } from "react-router-dom";

// One short factual line: ship window, free US shipping, 30-day exchanges, with a link to the policy.
export default function TrustLine({ text, className = "", onLinkClick }) {
  return (
    <p data-testid="trust-line" className={`text-[11px] leading-relaxed text-[#8A8A8A] ${className}`}>
      {text}{" "}
      <Link to="/policies/refunds" onClick={onLinkClick} className="underline underline-offset-2 hover:text-[#F2F0EB] transition-colors">
        Exchange policy
      </Link>
    </p>
  );
}
